$(window).bind("load resize", function () {
    resizeIframes();
});

function resizeIframes() {
    $('.iframe-wrapper > iframe').each(function () {
        var v = $(this);
        var iframeInitW = v.attr('width');
        var iframeInitH = v.attr('height');
        var ratio = iframeInitH / iframeInitW;
        var iframeW = v.width();
        var iframeNewW = iframeW * ratio;
        v.css('height', iframeNewW);
    });
}